module.exports = __webpack_public_path__ + "media/images/payments/bancontact-dark-9d1309edd965ab2193e17471cbbc9e00.svg";